import React from 'react'
import { Link } from "react-router-dom"
import "./Error.css"



function Error() {
  return (
    <div className='error'>
     <img src="https://img.freepik.com/free-vector/404-error-with-a-landscape-concept-illustration_114360-7898.jpg?size=626&ext=jpg&ga=GA1.2.148685086.1666508435"/>
      <p>お探しのページが見つかりませんでした。</p>
      <Link to="/">ホームに戻る</Link>
    </div>
  )
}

export default Error